<script setup lang="ts">
import ConciergeTakeover from './ConciergeTakeover.vue'
import { type ConciergeInputVariantName } from './ConciergeInputVariant.vue'
import { trackConciergeEvent } from './conciergeEventTracking'

// Thin composition point: the chosen input variant passes straight through to the
// takeover, where the input renders. Both variants write the same store, so nothing
// downstream depends on which one is picked.
withDefaults(defineProps<{
  variant?: ConciergeInputVariantName
}>(), { variant: 'free_text', })

onMounted(() => trackConciergeEvent('impression', { variant: __props.variant }))
</script>

<template>
  <div class="w-full">
    <ConciergeTakeover :variant="variant"/>
  </div>
</template>
